















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { isEmail } from '../../../../../src/jbi-shared/util/validate-email-domains.util';
import DraggableIcon from './DraggableIcon.vue';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';
import AttributeActionButtons from './AttributeActionButtons.vue';

@Component({
  components: {
    DraggableIcon,
    AttributeActionButtons
  }
})
export default class GroupLevelAttributeEmailField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  fieldErrorMsg: string = '';
  isEmailFormatCorrect: boolean = true;

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  @Watch('isRequired', { immediate: true })
  updateErrorState() {
    if (this.attributeValue.value) {
      this.validateEmailFormat();
      return;
    }

    this.attributeValue.hasFieldError = this.isRequired;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('attributeValue.value')
  validateEmailFormat(): void {
    if (this.isRequired && !this.attributeValue.value) {
      this.fieldErrorMsg = `${this.attributeValue.label} is required.`;
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    } else if (this.attributeValue.value) {
      // run validator when there's value
      this.isEmailFormatCorrect = isEmail(this.attributeValue.value as string);
    }

    if (!this.isEmailFormatCorrect) {
      this.fieldErrorMsg = 'Invalid email format.';
      this.attributeValue.hasFieldError = true;
    } else {
      this.fieldErrorMsg = '';
      this.attributeValue.hasFieldError = false;
    }

    this.updateAttributeValue(this.attributeValue);
  }
}
